export const FORM_IS_TOUCHED = 'customForm/FORM_IS_TOUCHED';
export const FORM_IS_UNTOUCHED = 'customForm/FORM_IS_UNTOCHED';
export const SUBMIT_IS_FAILED = 'customForm/SUBMIT_IS_FAILED';

export const REDUX_FORM_SET_SUBMIT_FAILED = '@@redux-form/SET_SUBMIT_FAILED';
export const REDUX_FORM_FOCUS = '@@redux-form/FOCUS';
export const REDUX_FORM_BLUR = '@@redux-form/BLUR';
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';
export const REDUX_FORM_INITIALIZE = '@@redux-form/INITIALIZE';
export const SET_EXPANDED_CARD_INDEX = 'customForm/SET_EXPANDED_CARD_INDEX';
